<template>
    <div class="codics-img-to-pdf-body" ref="contentRef">
        <div class="codics-img-to-pdf-upload-title">IMG转PDF</div>
        <el-upload action="files.kylebing.cn" width="100%" class="codics-img-to-pdf-upload" multiple
            :on-preview="handlePictureCardPreview" :http-request="uploadFile" :on-remove="handleRemove" ref="fmUpload"
            drag v-model="imgData" list-type="picture-card" :show-file-list="true">
            <el-image class="codics-img-to-pdf-upload-img"
                src="https://cdn.codics.cn/huayuan/img/%E4%B8%8A%E4%BC%A0%E6%96%87%E4%BB%B6.svg" fit="fill"></el-image>
            <div class="codics-img-to-pdf-upload-tip el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        </el-upload>
        <el-button style="margin-top: 0px;" type="success" @click="download" plain>生成并下载</el-button>
        <MyLoading v-show="uploadState"
            :show-txt="'正在处理图片' + (uploadProgress * 100 / pickData.length * 2).toFixed(2) + '%，请耐心等待...'"></MyLoading>
    </div>
</template>

<script>
import MyLoading from '@/components/MyLoading';
import JsPDF from "jspdf";
import html2canvas from 'html2canvas';
import Sortable from 'sortablejs';
export default {
    data() {
        return {
            uploadState: false,
            uploadProgress: 0,
            pickData: [],
            imgData: []
        }
    },
    mounted() {
        this.initDragSort();
    },
    methods: {
        initDragSort() {
            // 支持拖拽排序
            const el = this.$refs.fmUpload.$el.querySelectorAll('.el-upload-list')[0];
            Sortable.create(el, {
                onEnd: ({ oldIndex, newIndex }) => {
                    // 交换位置
                    const arr = this.imgData;
                    const page = arr[oldIndex];
                    arr.splice(oldIndex, 1);
                    arr.splice(newIndex, 0, page);
                }
            });
        },
        uploadFile(item) {

            this.pickData[this.pickData.length] = item;

            // this.uploadState = true;

            // this.uploadProgress+=1;

            // var reader = new FileReader();

            // reader.readAsDataURL(item.file);

            // reader.onload = () => {

            //     this.imgData[this.imgData.length] = reader.result;
            //     this.uploadProgress+=1;
            //     if(this.uploadProgress==this.pickData.length*2){
            //          this.uploadState = false;
            //          this.uploadProgress = 0;
            //     }
            // }
            // reader.onerror = function (err) {
            //     console.log(err);
            // }


        },
        enPdf() {

            const pdf = new jsPDF();

            this.uploadState = true;

            this.uploadProgress += 1;

            var reader = new FileReader();

            reader.readAsDataURL(item.file);

            reader.onload = () => {

                this.imgData[this.imgData.length] = reader.result;
                this.uploadProgress += 1;
                if (this.uploadProgress == this.pickData.length * 2) {
                    this.uploadState = false;
                    this.uploadProgress = 0;
                    this.imgData.forEach((item, index) => {

                        pdf.addImage(item, 'JPEG', 0, 0, pdf.internal.pageSize.getWidth(), pdf.internal.pageSize.getHeight());

                        if (index + 1 != this.imgData.length) pdf.addPage();

                    });

                    pdf.save('download.pdf');
                }
            }
            reader.onerror = function (err) {
                console.log(err);
            }



        },
        download() {
            const ref = this.$refs.contentRef // 截图区域
            let canvasScale = 2 //  生成的canvas越大 导出的pdf还原比例后越清晰
            html2canvas(ref, {
                backgroundColor: '#fff',
                useCORS: true, // 如果截图的内容里有图片,可能会有跨域的情况,加上这个参数,解决文件跨域问题
                // scale: 0.5
                scale: canvasScale,
            }).then((canvas) => {
                // 导出为一整张pdf
                this.loadOnePagePdf(canvas, canvasScale)
                // 导出为多页pdf
                this.loadPagingPdf(canvas)
                // 导出图片
                this.loadImg(canvas)
            })
        },
        // 导出为一整张pdf
        loadOnePagePdf(canvas, canvasScale) {
            let contentWidth = canvas.width
            let contentHeight = canvas.height
            let pageData = canvas.toDataURL('image/jpeg', 1.0)
            // 设置pdf的尺寸，pdf要使用pt单位 已知 1pt/1px = 0.75 pt = (px/scale)* 0.75
            let pdfX = (contentWidth + 10) / canvasScale * 0.75
            let pdfY = (contentHeight + 10) / canvasScale * 0.75 // 500为底部留白
            let pdf = new JsPDF('', 'pt', [pdfX, pdfY])
            let imgX = pdfX;

            let imgY = (contentHeight / canvasScale * 0.75); //内容图片这里不需要留白的距离
            pdf.addImage(pageData, 'jpeg', 0, 0, imgX, imgY)
            pdf.save("xxxxx.pdf");
        },
        // 导出为多页pdf
        loadPagingPdf(canvas) {
            let pdf = new JsPDF("p", "mm", "a4"); //A4纸，纵向
            let ctx = canvas.getContext("2d"),
                a4w = 210,
                a4h = 297, //A4大小，210mm x 297mm，四边各保留10mm的边距，显示区域190x277
                imgHeight = Math.floor((a4h * canvas.width) / a4w), //按A4显示比例换算一页图像的像素高度
                renderedHeight = 0;

            while (renderedHeight < canvas.height) {
                let page = document.createElement("canvas");
                page.width = canvas.width;
                page.height = Math.min(imgHeight, canvas.height - renderedHeight); //可能内容不足一页 //用getImageData剪裁指定区域，并画到前面创建的canvas对象中

                page
                    .getContext("2d")
                    .putImageData(
                        ctx.getImageData(
                            0,
                            renderedHeight,
                            canvas.width,
                            Math.min(imgHeight, canvas.height - renderedHeight)
                        ),
                        0,
                        0
                    );
                pdf.addImage(
                    page.toDataURL("image/jpeg", 1.0),
                    "JPEG",
                    0,
                    0,
                    a4w,
                    Math.min(a4h, (a4w * page.height) / page.width)
                ); //添加图像到页面，保留10mm边距
                renderedHeight += imgHeight;
                if (renderedHeight < canvas.height) {
                    pdf.addPage(); //如果后面还有内容，添加一个空页
                }
            }
            pdf.save("xxxxxx.pdf");
        },
        // 导出图片
        loadImg(canvas) {
            const dataURL = canvas.toDataURL('image/png')
            const creatDom = document.createElement('a')
            document.body.appendChild(creatDom)
            creatDom.href = dataURL
            creatDom.download = 'xxxxx'
            creatDom.click()
        }


    },
    components: {
        MyLoading
    }
}
</script>

<style>
.codics-img-to-pdf-body {
    height: fit-content;
    min-height: calc(100% - 120px);
    width: 100%;
    max-width: 1450px;
    left: 50%;
    transform: translateX(-50%);
    position: relative;
    float: left;
    box-sizing: border-box;
    padding: 0 20px 0 20px;
}

.codics-img-to-pdf-upload-title {
    height: 30px;
    width: 100%;
    position: relative;
    float: left;
    line-height: 30px;
    font-size: 14px;
    padding: 0 0 0 15px;
    border-left: 1px solid #E6A23C;
    margin-top: 15px;
    margin-bottom: 15px;
}

.codics-img-to-pdf-upload {
    width: 100vw;
    max-width: 1450px;

}

.codics-img-to-pdf-body .el-upload,
.codics-img-to-pdf-body .el-upload-dragger {
    width: 100%;
}

.codics-img-to-pdf-body .el-upload {
    border: none !important;
}

.codics-img-to-pdf-upload-img {
    height: 120px;
    width: 120px;
    position: absolute !important;
    margin: auto;
    top: -40px;
    left: 0;
    right: 0;
    bottom: 0;
}

.codics-img-to-pdf-upload-tip {
    height: 50px;
    width: fit-content;
    position: absolute;
    margin: auto;
    top: 120px;
    left: 0;
    right: 0;
    bottom: 0;
    line-height: 50px;
    text-align: center;
    font-size: 13px !important;
}

.codics-img-to-pdf-body .el-upload--picture-card {
    position: absolute !important;
    top: 60px;
    left: 20px;
    width: calc(100% - 40px);
}

.codics-img-to-pdf-body .el-upload-list {
    margin-top: 195px;
    float: inline-start;
    max-width: 1450px;
    width: calc(100% - 40px);
}

.el-upload-list__item-actions {
    cursor: grab !important;
}

.el-upload-list__item-actions:active {
    cursor: grabbing !important;
}
</style>